<div>
    <mat-form-field appearance="outline" class="search-filter">
        <mat-label>Sök</mat-label>
        <input matInput [(ngModel)]="searchTerm" (keyup)="filterSelectableValuesByQuery()" placeholder="Sök"
            class="search-input">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
</div>
<app-filter-input-chips [(selectedValues)]="this.filterValues" (selectedValuesChange)="applyFilter()"
    [tableId]="'user-table'"></app-filter-input-chips>